import { OrderFieldsSchemaState } from "../modules/orderFieldsSchema";

export const orderFieldsSchema = (state: { orderFieldsSchema: OrderFieldsSchemaState }) =>
  state.orderFieldsSchema.orderFieldsSchema;

export const loadOrderFieldsSchemaPending = (state: { orderFieldsSchema: OrderFieldsSchemaState }) =>
  state.orderFieldsSchema.loadOrderFieldsSchemaPending;

export const updateOrderFieldsSchemaPending = (state: { orderFieldsSchema: OrderFieldsSchemaState }) =>
  state.orderFieldsSchema.updateOrderFieldsSchemaPending;
